module.exports = __webpack_public_path__ + "img/logo.60a97c05.png";